"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var injection_service_1 = require("../../shared/injection/injection.service");
var MzModalService = (function () {
    function MzModalService(injectionService) {
        this.injectionService = injectionService;
    }
    /**
     * Open modal component.
     *
     * @param {Type<MzBaseModal>} componentClass
     * @param {*} [options={}]
     * @returns {ComponentRef<MzBaseModal>}
     * @memberof MzModalService
     */
    MzModalService.prototype.open = function (componentClass, options) {
        if (options === void 0) { options = {}; }
        var componentRef = this.injectionService.appendComponent(componentClass, options);
        componentRef.instance.modalComponent.onClose.first().subscribe(function () {
            componentRef.destroy();
        });
        return componentRef;
    };
    return MzModalService;
}());
MzModalService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
MzModalService.ctorParameters = function () { return [
    { type: injection_service_1.MzInjectionService, },
]; };
exports.MzModalService = MzModalService;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/modal/services/modal.service.js
// module id = ./node_modules/ng2-materialize/dist/modal/services/modal.service.js
// module chunks = vendor